import paginationComponents from './pageComponents.vue'
const pageComponents = {
  install: (Vue) => {
    Vue.component('pageComponents', paginationComponents)
  }
}
export default pageComponents
